define('plugin/invoice/view/InvoiceRecurringFlagView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#invoice_payment_recurring_flag_view',
        ui: {
            'recurringFlag': ':input'
        },
        events: {
            'change @ui.recurringFlag': 'onChangeFlag'
        },

        onChangeFlag: function () {
            this.triggerMethod('payment_processor:recurring', this.ui.recurringFlag.is(':checked'));
        }

    });

});
